import {UseCase} from "@livechat/shared";
import {AnswerTemplateAggregate} from "../aggregates";
import {AnswerTemplateGateway} from "../repositories";
import {map, Observable} from "rxjs";
import {AnswerTemplateDto} from "../../feature/answer-templates/domain/dtos";
import {answerTemplateAggregateToDto} from "../../feature/answer-templates/domain/utils";

export class UpdateAnswerTemplateUseCase implements UseCase<AnswerTemplateAggregate, Observable<AnswerTemplateDto>> {

  constructor(private answerTemplateRepo: AnswerTemplateGateway) {
  }

  execute(answerTemplate: AnswerTemplateAggregate): Observable<AnswerTemplateDto> {
    return this.answerTemplateRepo.update(answerTemplate)
      .pipe(map(answerTemplateAggregateToDto));
  }
}
